import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { TAGS_QUERY } from '../graphql/queries';
import { DELETE_TAG } from '../graphql/mutations';
import DataTable from '../components/DataTable';
import EmptyState from '../components/EmptyState';
import QueryError from '../components/QueryError';
import M3LinearProgress from '../components/M3Progress';
import TableActions from '../components/TableActions';
import TagFormDialog from '../components/TagFormDialog';

export default function TagsPage() {
  const { data, loading, error } = useQuery(TAGS_QUERY);
  const [deleteTag] = useMutation(DELETE_TAG, {
    refetchQueries: [{ query: TAGS_QUERY }],
    awaitRefetchQueries: true
  });
  const [formTag, setFormTag] = useState(null);
  const openCreate = () => setFormTag({ id: null });
  const openEdit = (tag) => setFormTag({ id: tag.id });

  const columns = [
    { key: 'name', title: 'Name' },
    { key: 'figuresCount', title: 'Figures', render: (v) => v || 0 }
  ];

  if (error)
    return (
      <div className="page-content">
        <QueryError error={error} onRetry={() => window.location.reload()} />
      </div>
    );

  if (loading)
    return (
      <div className="page-content">
        <M3LinearProgress indeterminate />
      </div>
    );

  if (!data?.tags?.length) {
    return (
      <div className="page-content">
        <EmptyState
          icon="label"
          title="No Tags"
          message="No tags have been created yet."
          action={
            <button className="btn btn-primary mt-3" onClick={openCreate}>
              New Tag
            </button>
          }
        />
        <TagFormDialog open={formTag !== null} tag={formTag} onClose={() => setFormTag(null)} />
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Tags</h1>
        <button className="btn btn-primary" onClick={openCreate}>
          <span className="material-symbols-rounded">add</span> New Tag
        </button>
      </div>
      <DataTable
        columns={columns}
        data={data.tags}
        loading={loading}
        rowKey="id"
        emptyMessage="No tags found"
        actions={(tag) => (
          <TableActions
            items={[
              { icon: 'edit', label: 'Edit', onClick: () => openEdit(tag) },
              {
                icon: 'delete',
                label: 'Delete',
                danger: true,
                onClick: () => {
                  if (window.confirm(`Delete "${tag.name}"? This cannot be undone.`)) {
                    deleteTag({ variables: { input: { id: tag.id } } });
                  }
                }
              }
            ]}
          />
        )}
      />
      <TagFormDialog open={formTag !== null} tag={formTag} onClose={() => setFormTag(null)} />
    </div>
  );
}
